// Resume templates offered in the picker and the template gallery.
// Everyone can preview every template; premium templates can only be
// downloaded on the plans in PREMIUM_TEMPLATE_PLANS.
export interface ResumeTemplateInfo {
  id: string;
  name: string;
  description: string;
  bestFor: string;
  premium: boolean;
}

export const RESUME_TEMPLATES: ResumeTemplateInfo[] = [
  {
    id: "simple",
    name: "Classic Simple",
    description: "Simple layout for entry level professionals",
    bestFor: "Any role, especially early-career",
    premium: false,
  },
  {
    id: "modern",
    name: "Modern Professional",
    description: "Clean sans-serif layout with a subtle accent color",
    bestFor: "Most industries: tech, product, marketing, operations",
    premium: true,
  },
  {
    id: "executive",
    name: "Executive Serif",
    description: "Traditional serif layout with a centered header",
    bestFor: "Finance, law, consulting and senior roles",
    premium: true,
  },
  {
    id: "compact",
    name: "Compact Technical",
    description: "Dense one-page layout with skills, experience and projects up front",
    bestFor: "Software engineering, data and IT roles",
    premium: true,
  },
  {
    id: "graduate",
    name: "Fresh Graduate",
    description: "Education, skills and projects up front, with a teal accent",
    bestFor: "Freshers, students, interns and campus placements",
    premium: true,
  },
  {
    id: "corporate",
    name: "Corporate Banner",
    description: "Bold colored header band with accent-bar section headings",
    bestFor: "Management, sales, operations and business roles",
    premium: true,
  },
  {
    id: "creative",
    name: "Creative Accent",
    description: "Elegant serif name, burgundy accent and a top color strip",
    bestFor: "Marketing, design, content and communications roles",
    premium: true,
  },
];

export const PREMIUM_TEMPLATE_PLANS = ["plus", "pro"];

export const canDownloadTemplate = (
  template: ResumeTemplateInfo | undefined,
  subscription: string
) => !template?.premium || PREMIUM_TEMPLATE_PLANS.includes(subscription);

export const getTemplate = (id: string) =>
  RESUME_TEMPLATES.find((template) => template.id === id);
